import { useContext, useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom';
import { ApiDocModuleContext, DashboardContext } from '../../../../context';
import { CustomTabProps } from '../../../../types';
import ArtifactContainer from '../../../../components/artifacts/ArtifactContainer';
import TabContainer from '../../../../components/containers/TabContainer';
import { GAHelper } from '../../../../helpers/ga.helper';
import DocForumComments from '../../../../components/helpDocs/DocForumComments';
import AppDataWrapper from '../../../../components/containers/AppDataWrapper';
import Error404 from '../../../../components/error/Error404';

export default function ApiDocVisor() {
  let { apiId } = useParams();
  const context = useContext(ApiDocModuleContext)
  const dashboardContext = useContext(DashboardContext)
  const restData = dashboardContext?.appData['rest']
  const tabGroup = useMemo<CustomTabProps[]>(() => {
    let tabs = []
    if (context?.resourcesData) {
      let artifacts = context.resourcesData.versions[0]?.artifacts
      artifacts?.forEach(a => {
        tabs.push({
          label: dashboardContext?.getCatalog('ART')?.find(t => t.value === a.type)?.label || a.type,
          panel: <div>
            {context.resourcesData && <ArtifactContainer appModule='rest' resource={context?.resourcesData} artifact={a} />}
          </div>
        })
      })
      tabs.push({
        label: 'Comentarios',
        panel: <section className='section'>
          <DocForumComments resource={context.resourcesData} />
        </section>
      })
    }
    return tabs
  }, [context?.resourcesData])
  useEffect(() => {
    if (apiId) {
      let [group, apiName] = apiId.split('-')
      let foundApiTarget = restData?.get(group)?.find(item => item.name === apiId)
      context?.setResourcesData(foundApiTarget)
      if (foundApiTarget) {
        GAHelper.setRestServiceView(group, apiName, dashboardContext?.appData['afore'], dashboardContext?.appData['user'])
      }
    }
  }, [apiId, restData])

  return (
    <AppDataWrapper>
      {context?.resourcesData ?
        <TabContainer tabs={tabGroup} /> :
        <Error404 label='No se encontro la API solicitada' />}
    </AppDataWrapper>
  )
}
